export const CREATE_EDIT_TRANSFER_ITEMS_LOADING =
  'CREATE_EDIT_TRANSFER_ITEMS_LOADING';
export const CREATE_EDIT_TRANSFER_ITEMS = 'CREATE_EDIT_TRANSFER_ITEMS';
export const TRANSFER_ITEMS_LOADING_ERROR = 'TRANSFER_ITEMS_LOADING_ERROR';
export const FETCHING_TRANSFER_DETAIL = 'FETCHING_TRANSFER_DETAIL';
export const SELECTED_TRANSFER_DETAIL = 'SELECTED_TRANSFER_DETAIL';
export const FETCHING_TRANSFER_DETAIL_ERROR = 'FETCHING_TRANSFER_DETAIL_ERROR';
export const CLEAR_TRANSFER_ERROR_SUCCESS = 'CLEAR_TRANSFER_ERROR_SUCCESS';
export const SUBMITTING_TRANSFER_DETAIL = 'SUBMITTING_TRANSFER_DETAIL';
export const TRANSFER_DETAIL_SUBMIT = 'TRANSFER_DETAIL_SUBMIT';
export const SUBMIT_TRANSFER_DETAIL_ERROR = 'SUBMIT_TRANSFER_DETAIL_ERROR';
export const RE_TRANSFER_ITEM_LIST = 'RE_TRANSFER_ITEM_LIST';
export const VIEW_TRANSFER_ITEMS = 'VIEW_TRANSFER_ITEMS';
export const GET_TO_SITES = 'GET_TO_SITES';



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transfer/state/createEditTransfer/types.js